export default __webpack_public_path__ + "static/media/botao-ios-app.0638af65.png";